import * as actions from './danmu.action';
//import * as _ from 'lodash';

export interface DanmuState {
    loading: boolean;
    list: Array<any>;
  //  cue: Array<any>;
  //  flying: Array<any>;
  //  bullets: Array<any>;
   // barrels: Array<any>;
   // fixtops: Array<any>;
   // fixbottoms: Array<any>;
   // complete: Array<any>;
   // approvedShot: Array<any>;
   // currentTime: number;
    paused: any;
    setCurrentTime: number;
    keywordFilter: Array<any>;
    userFilter: Array<any>;
    fullScreen: boolean;
    blockTop: boolean;
    blockBottom: boolean;
    blockLeft: boolean;
    speed: number;
    showDanmu: boolean;
    fontSize: number;
    opacity: number;
    fontFamily: number;
    danmuKey: string;
    outputType: number;
    outputColor: number;
    userSettings: any;
}


// function createInitalBarrels(count: number) {
//     const innerWidth = window.innerWidth;
//     // 限制小屏幕显示弹幕行数
//     if (innerWidth <= 1680) {
//         count = 8;
//     }
//     const result = [];
//     for (let i = 0; i < count + 1; i++) {
//         result.push({ index: i, stack: 0 });
//     }

//     return result;
// }

export const initialState: DanmuState = {
    loading: false,
    list: [],
   // cue: [],
   // flying: [],
   // bullets: [],
   // barrels: createInitalBarrels(13),
   // fixtops: createInitalBarrels(10),
   // fixbottoms: createInitalBarrels(6),
   // complete: [],
   // approvedShot: [],
   // currentTime: 0,
    paused: null,
    setCurrentTime: 0,
    keywordFilter: [],
    userFilter: [],
    fullScreen: false,
    blockTop: false,
    blockBottom: false,
    blockLeft: false,
    speed: 2,
    // showDanmu: true,
    // 根据保存的cookie初始化弹幕开关
    showDanmu: true,
    fontSize: 18,
    opacity: 4,
    fontFamily: 4,
    danmuKey: '',
    outputType: 0,
    outputColor: 0,
    userSettings: {
        includeAvatar: false,
        includeLocation: false,
        userSettingsLoaded: false,
    }
};

export function DanmuReducer(
    state: DanmuState = initialState,
    action: actions.Actions
): DanmuState {
    switch (action.type) {
        case actions.DanmuActionTypes.DANMU_RESET: {
            return {
                ...state,
                list: [],
           //     cue: [],
           //     bullets: [],
             //   barrels: createInitalBarrels(13),
              //  fixtops: createInitalBarrels(10),
               // fixbottoms: createInitalBarrels(6),
               // approvedShot: [],
            };
        }
        case actions.DanmuActionTypes.DANMU_LIST_REQUIRED: {
            return {
                ...state,
                loading:true
            }
            // Object.assign({}, state, {
            //     loading: true,
            // });
        }
        case actions.DanmuActionTypes.DANMU_LIST_LOADED: {

            return {
                ...state,
                loading:false,
                list:action.payload ? [... action.payload ].sort((a, b) => a.second >= b.second ? 1 : -1) : []
            }
            
            // Object.assign({}, state, {
            //     loading: false,
            //     list: action.payload ? [... action.payload ].sort((a, b) => a.second >= b.second ? 1 : -1) : []
            // });
        }
        case actions.DanmuActionTypes.DANMU_LIST_LOAD_FAILURE: {
            return {
                ...state,
                loading:false
             
            }
            //  Object.assign({}, state, {
            //     loading: false,
            // });
        }
        // case actions.DanmuActionTypes.DANMU_LOAD_BULLET: {
        //     return state;
        // }
        // case actions.DanmuActionTypes.DANMU_BULLET_LOADED: {
        //     return {
        //         ...state,
        //         bullets: [...state.bullets, {
        //             ...action.payload.bullet,
        //         }],
        //     };
        // }
      
        // case actions.DanmuActionTypes.DANMU_FIRE: {
        //     return {
        //         ...state,
        //         bullets: [...state.bullets.filter(b => b.guid !== action.payload.guid)],
        //         flying: [...state.flying, action.payload]
        //     };
        // }
        // case actions.DanmuActionTypes.DANMU_RELEASE_BARREL: {
        //     if (action.payload.position === BarrelType.Barrel) {
        //         return {
        //             ...state,
        //             barrels: [...state.barrels.map(b => {
        //                 if (b.index === action.payload.barrel) {
        //                     b.stack = b.stack > 0 ? b.stack - 1 : 0;
        //                 }
        //                 return b;
        //             })]
        //         };
        //     } else if (action.payload.position === BarrelType.FixTop) {
        //         return {
        //             ...state,
        //             fixtops: [...state.fixtops.map(fixtop => {
        //                 if (fixtop.index === action.payload.barrel) {
        //                     fixtop.stack = fixtop.stack > 0 ? fixtop.stack - 1 : 0;
        //                 }
        //                 return fixtop;
        //             })]
        //         };
        //     } else if (action.payload.position === BarrelType.FixBottom) {
        //         return {
        //             ...state,
        //             fixbottoms: [...state.fixbottoms.map(fixbottom => {
        //                 if (fixbottom.index === action.payload.barrel) {
        //                     fixbottom.stack = fixbottom.stack > 0 ? fixbottom.stack - 1 : 0;
        //                 }
        //                 return fixbottom;
        //             })]
        //         };
        //     }
        //     return state;
        // }
        // case actions.DanmuActionTypes.DANMU_DESTROY_BULLET: {
        //     return {
        //         ...state,
        //         flying: [...state.flying.filter(b => b.guid !== action.payload)],
        //         complete: [...state.complete, action.payload]
        //     };
        // }
        // case actions.DanmuActionTypes.DANMU_BULLET_DESTROYED: {
        //     return {
        //         ...state,
        //         complete: [...state.complete.filter(c => c !== action.payload)]
        //     };
        // }
        case actions.DanmuActionTypes.DANMU_PAUSE: {
            return {
                ...state,
                paused: action.payload,
            };
        }
        case actions.DanmuActionTypes.DANMU_PLAY: {
            return {
                ...state,
                paused: 0,
            };
        }
        // case actions.DanmuActionTypes.DANMU_TIME_UPDATED: {
        //     return {
        //         ...state,
        //         currentTime: action.payload,
        //     };
        // }
        case actions.DanmuActionTypes.DANMU_SEND: {
            return {
                ...state,
            };
        }
        case actions.DanmuActionTypes.DANMU_NEW: {
            const res = {
                ...state,
             //   cue: [...state.cue, action.payload],
                list: [...state.list, { ...action.payload }].sort((a, b) => (a.second >= b.second) ? 1 : -1)
            };
            return res;
        }
        case actions.DanmuActionTypes.DANMU_SET_CURRENT_TIME: {
            return {
                ...state,
                setCurrentTime: action.payload
            };
        }
        // case actions.DanmuActionTypes.DANMU_REQUIRE_BARREL: {
        //     if (action.payload.bullet.position === BarrelType.Barrel) {
      
        //         const crashTime = action.payload.canvasSize / action.payload.speed;
        //         const list = [...state.barrels];
        //         const now = new Date().getTime();
        //         const filted = list.filter(b => {
        //             if ((!b.updated) || ((crashTime) > (b.duration - (now - b.updated)))) {
        //                 return b;
        //             }
        //         });
        //         let sorted;
        //         if (filted.length) {
        //             sorted = filted;
        //         } else {
        //             sorted = list;
        //         }
        //         ////
        //         sorted = sorted.sort(function (a, b) {
        //             return a.stack - b.stack || a.index - b.index;
        //         });
             
        //         return {
        //             ...state,
        //             approvedShot: [
        //                 ...state.approvedShot,
        //                 {
        //                     barrel: sorted[0],
        //                     bullet: action.payload.bullet.guid
        //                 }
        //             ]
        //         };



        //     } else if (action.payload.bullet.position === BarrelType.FixTop) {
        //         const sorted = [...state.fixtops].sort(function (a, b) {
        //             return a.stack - b.stack || a.index - b.index;
        //         });
        //         return {
        //             ...state,
        //             approvedShot: [
        //                 ...state.approvedShot,
        //                 {
        //                     barrel: sorted[0],
        //                     bullet: action.payload.bullet.guid
        //                 }
        //             ]
        //         };
        //     } else {
        //         const sorted = [...state.fixbottoms].sort(function (a, b) {
        //             return a.stack - b.stack || a.index - b.index;
        //         });
        //         return {
        //             ...state,
        //             approvedShot: [
        //                 ...state.approvedShot,
        //                 {
        //                     barrel: sorted[0],
        //                     bullet: action.payload.bullet.guid
        //                 }
        //             ]
        //         };
        //     }
        // }
        // case actions.DanmuActionTypes.DANMU_BULLET_FIRED: {
        //     if (action.payload.bullet.position === BarrelType.Barrel) {
        //         //console.log(state.barrels)
        //         return {
        //             ...state,
        //             barrels: [... state.barrels].map(b => {
        //                 if (b.index === action.payload.barrel.index) {
        //                     b.stack += 1;
        //                     b.updated = new Date().getTime();
        //                     b.duration = action.payload.duration;
        //                 }
        //                 return b;
        //             }),
        //             approvedShot: [...state.approvedShot].filter(a => a.bullet !== action.payload.bullet.guid)
        //         };
        //     } else if (action.payload.bullet.position === BarrelType.FixTop) {
        //         return {
        //             ...state,
        //             fixtops: [...state.fixtops].map(b => {
        //                 if (b.index === action.payload.barrel.index) {
        //                     b.stack += 1;
        //                 }
        //                 return b;
        //             }),
        //             approvedShot: [...state.approvedShot].filter(a => a.bullet !== action.payload.bullet.guid)
        //         };
        //     } else {
        //         return {
        //             ...state,
        //             fixbottoms: [...state.fixbottoms].map(b => {
        //                 if (b.index === action.payload.barrel.index) {
        //                     b.stack += 1;
        //                 }
        //                 return b;
        //             }),
        //             approvedShot: [...state.approvedShot].filter(a => a.bullet !== action.payload.bullet.guid)
        //         };
        //     }
        // }
        case actions.DanmuActionTypes.DANMU_ADD_KEYWORD_FILTER: {
            return {
                ...state,
                keywordFilter: state.keywordFilter.indexOf(action.payload) === -1
                    ? [...state.keywordFilter, action.payload]
                    : [...state.keywordFilter]
            };
        }
        case actions.DanmuActionTypes.DANMU_REMOVE_KEYWORD_FILTER: {
            return {
                ...state,
                keywordFilter: [...state.keywordFilter.filter(keyword => keyword !== action.payload)],
            };
        }
        case actions.DanmuActionTypes.DANMU_ADD_USER_FILTER: {
            return {
                ...state,
                userFilter: state.userFilter.findIndex(p => p.id == action.payload.id) > -1 ? [...state.userFilter] :
                    [...state.userFilter, action.payload]
            };
        }
        case actions.DanmuActionTypes.DANMU_REMOVE_USER_FILTER: {
            return {
                ...state,
                userFilter: [...state.userFilter.filter(filters => filters.id !== action.payload.id)],
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_FULL_SCREEN: {
            return {
                ...state,
                fullScreen: action.payload
            };
        }
        case actions.DanmuActionTypes.DANMU_BLOCK_TOP: {
            return {
                ...state,
                blockTop: !state.blockTop
            };
        }
        case actions.DanmuActionTypes.DANMU_BLOCK_BOTTOM: {
            return {
                ...state,
                blockBottom: !state.blockBottom
            };
        }
        case actions.DanmuActionTypes.DANMU_BLOCK_LEFT: {
            return {
                ...state,
                blockLeft: !state.blockLeft
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_SPEED: {
            return {
                ...state,
                speed: action.payload
            };
        }
        case actions.DanmuActionTypes.DANMU_TOGGLE_DANMU: {
            return {
                ...state,
                showDanmu: !state.showDanmu
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_FONT_SIZE: {
            return {
                ...state,
                fontSize: action.payload
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_OPACITY: {
            return {
                ...state,
                opacity: action.payload
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_FONT_FAMILY: {
            return {
                ...state,
                fontFamily: action.payload
            };
        }
        // case actions.DanmuActionTypes.DANMU_RESET_ALL_BARRELS: {
        //     return {
        //         ...state,
        //         barrels: createInitalBarrels(13),
        //         fixtops: createInitalBarrels(10),
        //         fixbottoms: createInitalBarrels(6),
        //     };
        // }
        case actions.DanmuActionTypes.DANMU_SET_DANMU_KEY: {
            return {
                ...state,
                danmuKey: action.payload,
            };
        }
        // case actions.DanmuActionTypes.DANMU_REMOVE_DANMU: {
        //     return {
        //         ...state,
        //     };
        // }
        case actions.DanmuActionTypes.DANMU_REMOVED: {
            return {
                ...state,
                list: [...state.list.filter(l => l.guid !== action.payload)]
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_OUTPUT_TYPE: {
            return {
                ...state,
                outputType: action.payload
            };
        }
        case actions.DanmuActionTypes.DANMU_SET_OUTPUT_COLOR: {
            return {
                ...state,
                outputColor: action.payload
            };
        }
        case actions.DanmuActionTypes.DANMU_GET_USER_SETTINGS_SUCCESS: {
            return { ...state, userSettings: { ...action.payload, userSettingsLoaded: true } }
        }
        default:
            return state;
    }
}
